module.exports = __webpack_public_path__ + "img/nationalparks.686dc862.jpg";